// extracted by mini-css-extract-plugin
module.exports = {"widget":"UploadWidget_widget__3p18v","progress":"UploadWidget_progress__3hZn-"};